import tableContentComponent from './index.vue'

const tableContent = {
    install : (Vue) => {
        Vue.component('tableContent', tableContentComponent);
    }
}

export default tableContent



// WEBPACK FOOTER //
// ./src/base/table/index.js